__turbopack_context__.v({
  "card": "DealCard-module-scss-module__sQ7nYa__card",
  "clockIcon": "DealCard-module-scss-module__sQ7nYa__clockIcon",
  "copy": "DealCard-module-scss-module__sQ7nYa__copy",
  "copyLine": "DealCard-module-scss-module__sQ7nYa__copyLine",
  "image": "DealCard-module-scss-module__sQ7nYa__image",
  "imageWrapper": "DealCard-module-scss-module__sQ7nYa__imageWrapper",
  "interactive": "DealCard-module-scss-module__sQ7nYa__interactive",
  "link": "DealCard-module-scss-module__sQ7nYa__link",
  "tag": "DealCard-module-scss-module__sQ7nYa__tag",
  "tagSpacer": "DealCard-module-scss-module__sQ7nYa__tagSpacer",
});
